import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import BackHeader from "../components/backHeader";
import { toast } from "react-toastify";
import { BlackButton } from "../components/buttonContainer";
import { apiurl } from "../config/config";
import { useUser } from "../config/userProvider";
import { useNavigate } from "react-router-dom";
import { CountryAndStateData } from "../constants/constant";


const CreateSegment = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    criteria: "",
    value: "",
  });
  const [customers, setCustomers] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [createSegmentLoading, setCreateSegmentLoading] = useState(false);
  const [fetchCustomerLoading, setFetchCustomerLoading] = useState(false);
  console.log("formData", formData);
  console.log("customers", customers);
  console.log("selectedCustomers", selectedCustomers);

  const { userData } = useUser();
  const vendorObjId = userData?.vendorDetails?.vendorObjId;
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const fetchCustomers = async () => {
    if (formData.name === "" || formData.description === "" || formData.criteria === "" || formData.value === "") {
      toast.error("Please fill all the required fields, and then try again.");
      return;
    } else {
      // try {
      //   const response = await axios.post("/api/fetch-customers", {
      //     criteria: formData.criteria,
      //     value: formData.value,
      //   });
      //   setCustomers(response.data.customers);
      // } catch (error) {
      //   console.error("Error fetching customers:", error);
      // }
      setFetchCustomerLoading(true);
      try {
        const requestBody = {
          criteria: {
            [`addressDetails.${formData.criteria}`]: formData.value, // Dynamically set criteria and value
          },
        };

        const response = await axios.post(`${apiurl}/admin/v1/segment/fetchcustomer`, requestBody, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        // Handle success response
        // console.log("Fetched Customers:", response.data);
        // return response.data;
        if (response?.data?.success === true) {
          setFetchCustomerLoading(false);
          toast.success(response.data.message);
          setCustomers(response?.data?.data);
        } else {
          setFetchCustomerLoading(false);
          toast.error(response.data.message ? response.data.message : "Error in fetching customers, Please try again later.")
        }
      } catch (error) {
        // Handle errors
        setFetchCustomerLoading(false);
        console.error("Error fetching customers:", error.response || error.message);
        throw error;
      }
    }

  };

  const handleCustomerSelection = (customerId) => {
    setSelectedCustomers((prev) =>
      prev.includes(customerId)
        ? prev.filter((id) => id !== customerId)
        : [...prev, customerId]
    );
  };
  const toggleSelectAllCustomers = () => {
    if (selectedCustomers.length === customers.length) {
      setSelectedCustomers([]);
    } else {
      setSelectedCustomers(customers.map((customer) => customer._id));
    }
  };

  const createSegment = async (e) => {
    e.preventDefault();
    if (selectedCustomers <= 0) {
      toast.error("Please select customers, and then try again.");
      return;
    } else {
      setCreateSegmentLoading(true);
      try {
        const payload = {
          vendorObjId: vendorObjId,
          name: formData.name,
          description: formData.description,
          criteria: {
            [formData.criteria]: formData.value,
          },
          type: "general",
          customerObjIds: selectedCustomers,
        };

        const response = await axios.post(`${apiurl}/admin/v1/segment/create`, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log("Segment created successfully:", response.data);
        if (response?.data?.success === true) {
          setCreateSegmentLoading(false);
          toast.success(response?.data?.message || "Segment created successfully");
          navigate("/customers/segments");
        } else {
          setCreateSegmentLoading(false);
          toast.error("Error in creating segment, Please try again later.")
        }
        // Handle success (e.g., show a success message, clear form, etc.)
      } catch (error) {
        setCreateSegmentLoading(false);
        console.error("Error creating segment:", error.response?.data || error.message);
        // Handle error (e.g., show an error message)
      }

    }
  };

  return (
    <Layout>
      <Container overflow={"overflow-hidden"}>
        <motion.div
          className="p-6 w-full h-full overflow-scroll bg-white"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="pb-5">
            <BackHeader
              title="Create Segment"
              backButton={true}
              link="/customers/segments"

            />
          </div>
          {/* <h2 className="text-2xl font-bold mb-4">Create Segment</h2> */}

          <form className="space-y-4">
            <div>
              <label className="block font-medium text-slate-500">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="w-full p-2 border rounded"
                placeholder="Segment Name"
              />
            </div>

            <div>
              <label className="block font-medium text-slate-500">Description</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                className="w-full p-2 border rounded"
                placeholder="Segment Description"
              />
            </div>

            <div>
              <label className="block font-medium text-slate-500">Criteria</label>
              <select
                name="criteria"
                value={formData.criteria}
                onChange={handleInputChange}
                className="w-full p-2 border rounded"
              >
                <option value="">Select Criteria</option>
                <option value="city">City</option>
                <option value="province_code">State</option>
                {/* <option value="order_value">Order Value</option> */}
              </select>
            </div>

            {/* {formData.criteria && (
              {
                formData.criteria === "province_code" ? 
                <div>
                  <label className="block font-medium text-slate-500">
                    State
                  </label>
                  <input
                    type="text"
                    name="value"
                    value={formData.value}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded"
                    placeholder={`Select State`}
                  />
                </div>
                  :
                  <div>
                    <label className="block font-medium text-slate-500">
                      {formData.criteria.charAt(0).toUpperCase() + formData.criteria.slice(1)}
                    </label>
                    <input
                      type="text"
                      name="value"
                      value={formData.value}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded"
                      placeholder={`Enter ${formData.criteria.charAt(0).toUpperCase() + formData.criteria.slice(1)}`}
                    />
                  </div>
              }
            )} */}

{formData.criteria && (
  <>
    {formData.criteria === "province_code" ? (
      <div>
        <label className="block font-medium text-slate-500">
          State
        </label>
        <select
          name="value"
          value={formData.value}
          onChange={handleInputChange}
          className="w-full p-2 border rounded"
        >
          <option value="" disabled>
            Select State
          </option>
          {/* Dynamically map states for India */}
          {Object.entries(CountryAndStateData.IN.states).map(([stateCode, stateName]) => (
            <option key={stateCode} value={stateCode}>
              {stateName}
            </option>
          ))}
        </select>
      </div>
    ) : (
      <div>
        <label className="block font-medium text-slate-500">
          {formData.criteria.charAt(0).toUpperCase() + formData.criteria.slice(1)}
        </label>
        <input
          type="text"
          name="value"
          value={formData.value}
          onChange={handleInputChange}
          className="w-full p-2 border rounded"
          placeholder={`Enter ${formData.criteria.charAt(0).toUpperCase() + formData.criteria.slice(1)}`}
        />
      </div>
    )}
  </>
)}


            <div className="flex justify-between">
              {/* <button
                type="button"
                onClick={fetchCustomers}
                className="bg-slate-500 text-white px-4 py-2 rounded mt-4"
                // disabled={formData.name === "" || formData.description === "" || formData.criteria === "" || formData.value === ""}
              >
                Fetch Customers
              </button> */}
              <BlackButton handleSubmit={fetchCustomers} title="Fetch Customers" backgroundColor="rgb(71 85 105)" loading={fetchCustomerLoading} loadingTitle="Fetching ..." />
              <BlackButton handleSubmit={createSegment} title="Create Segment" loading={createSegmentLoading} loadingTitle="Creating ..." />
              {/* <button
                onClick={createSegment}
                className="bg-green-500 text-white px-6 py-2 rounded mt-4"
              >
                Create Segment
              </button> */}
            </div>
          </form>

          {customers.length > 0 && (
            // <div className="mt-6">
            //   <h3 className="font-semibold mb-2">Customers</h3>
            //   <ul className="space-y-2">
            //     {customers.map((customer) => (
            //       <li key={customer._id} className="flex items-center space-x-4">
            //         <input
            //           type="checkbox"
            //           checked={selectedCustomers.includes(customer._id)}
            //           onChange={() => handleCustomerSelection(customer._id)}
            //         />
            //         <div>
            //           <p>{customer.name || "Unnamed Customer"}</p>
            //           <p className="text-sm text-gray-600">{customer.email}</p>
            //         </div>
            //       </li>
            //     ))}
            //   </ul>
            // </div>

            <div className="relative overflow-y-auto h-full sm:rounded-lg">
              <h3 className="font-semibold text-xl text-slate-500 my-4">Customers :</h3>
              <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0">
                  <tr>
                    <th scope="col" className="p-4">
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          checked={customers.length === selectedCustomers.length}
                          onChange={toggleSelectAllCustomers}
                          className="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                        />
                      </div>
                    </th>
                    <th scope="col" className="pl-4 sm:pl-6 py-3">
                      S. No.
                    </th>
                    <th scope="col" className="py-3">
                      Name
                    </th>
                    <th scope="col" className="py-3">
                      Email
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {customers &&
                    customers.length > 0 &&
                    customers.map((customer, index) => (
                      <tr
                        key={customer._id}
                        className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"
                          } border-b h-10`}
                      >
                        <td className="p-4">
                          <div className="flex items-center">
                            <input
                              type="checkbox"
                              checked={selectedCustomers.includes(customer._id)}
                              onChange={() => handleCustomerSelection(customer._id)}
                              className="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                            />
                          </div>
                        </td>
                        <th
                          scope="row"
                          className="pl-4 sm:pl-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                        >
                          {index + 1}
                        </th>
                        <td className="py-4">{customer.name || "Unnamed Customer"}</td>
                        <td className="py-4 text-gray-600">{customer.email || "N/A"}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

          )}


        </motion.div>
      </Container>
    </Layout>
  );
};

export default CreateSegment;
